// extracted by mini-css-extract-plugin
module.exports = {"root":"CooperationScreen_root__13vCi","centered":"CooperationScreen_centered__M-rX2","benefits":"CooperationScreen_benefits__3D0Of","benefitGrid":"CooperationScreen_benefitGrid__BRZHo","benefitHolder":"CooperationScreen_benefitHolder__1I0iX"};
    if(module.hot) {
      // 1586964018730
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  